<template>
    <div>
        <nav-bar />
        <div class="main">
            <section
                class="hero-section ptb-100 background-img"
                style="
                    background: url('img/hero.jpg') no-repeat center center / cover;
                "
            >
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-md-9 col-lg-7">
                            <div class="page-header-content text-white text-center">
                                <h1 class="text-white mb-0">Privacy Policy</h1>
                                <div class="custom-breadcrumb">
                                    <ol
                                        class="breadcrumb d-inline-block bg-transparent list-inline py-0"
                                    >
                                        <li class="list-inline-item breadcrumb-item">
                                            <router-link
                                                class="nav-link page-scroll bold matchBtn"
                                                to="/"
                                                >{{ $t("home") }}</router-link
                                            >
                                        </li>
                                        <li
                                            class="list-inline-item breadcrumb-item active"
                                        >
                                            Privacy Policy
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="gray-light-bg ptb-100">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-10 col-lg-9">
                            <div class="privacy-content">
                                <h2 class="mb-4">
                                    Personal Information Collection Statement
                                </h2>
                                <p>
                                    In this Statement, "we" refers to Star Jasmine
                                    Employment Centre. In complying with the
                                    requirements of the Personal Data (Privacy)
                                    Ordinance, Chapter 486 of the laws of the Hong
                                    Kong ("Ordinance"), we strive to safeguard your
                                    data privacy. This Statement sets out matters
                                    relating to the collection and use of your
                                    personal data.
                                </p>

                                <h4 class="mt-5 mb-3">Collection of Your Data</h4>
                                <p>
                                    A. From time to time, it is necessary for us to
                                    collect your personal data for providing you
                                    with updates, services and products described in
                                    the "Purpose and Use of Your Data" section
                                    below. It is not obligatory to supply the
                                    requested personal data but if you fail to
                                    supply the requested data or any part thereof,
                                    we may not be able to provide you with the
                                    updates, services and products.
                                </p>
                                <p>
                                    B. We may also generate and compile information
                                    about you. Personal data provided by you and all
                                    information generated and compiled by us about
                                    you from time to time is collectively referred
                                    to as "Your Data".
                                </p>

                                <h4 class="mt-5 mb-3">
                                    Purpose and Use of Your Data
                                </h4>
                                <p>
                                    C. We may use Your Data for one or more of the
                                    following purposes from time to time:
                                </p>
                                <ul>
                                    <li>providing updates, services and products;</li>
                                    <li>
                                        communicating with you (including responding
                                        to your enquiries or requests for
                                        information);
                                    </li>
                                    <li>
                                        designing, reviewing, evaluating and
                                        enhancing our services and products
                                        (including conducting research, survey and
                                        analysis for those purposes);
                                    </li>
                                    <li>
                                        investigating and handling complaints,
                                        claims or incidents involving us or any of
                                        our customers, visitors or website users;
                                    </li>
                                    <li>
                                        preventing, detecting or investigating
                                        suspicious or illegal activities;
                                    </li>
                                    <li>
                                        making disclosure when required by any law,
                                        court order, direction, code or guideline
                                        applicable in or outside Hong Kong; and
                                    </li>
                                    <li>purposes relating to any of the above.</li>
                                </ul>

                                <h4 class="mt-5 mb-3">Transfer of Your Data</h4>
                                <p>
                                    D. Your Data will not generally be disclosed or
                                    transferred to any other party in a form that
                                    would identify you except in the following
                                    circumstances:
                                </p>
                                <ul>
                                    <li>
                                        We may disclose Your Data to any
                                        governmental or law enforcement agency,
                                        judicial body or regulatory authority to
                                        whom we are required to make disclosure
                                        according to any law, regulation, court
                                        order, direction, code or guideline.
                                    </li>
                                    <li>
                                        In addition, Your Data may be accessed by,
                                        disclosed or transferred to any person under
                                        a duty of confidentiality to us (including
                                        our accountants, auditors, legal advisers or
                                        other professional advisers) and any of our
                                        subsidiaries, holding companies, associated
                                        companies or affiliated companies for the
                                        purposes described in the "Purpose and Use
                                        of Your Data" section above.
                                    </li>
                                </ul>
                                <p>
                                    E. As the parties mentioned above may be located
                                    outside Hong Kong, Your Data may be transferred
                                    out of Hong Kong.
                                </p>

                                <h4 class="mt-5 mb-3">
                                    Use of Your Data in Direct Marketing
                                </h4>
                                <p>
                                    F. We are allowed to use Your Data in direct
                                    marketing only if you consent or do not object.
                                    In connection with direct marketing, we intend:
                                </p>
                                <ul>
                                    <li>
                                        to use your name and contact details,
                                        profiling information, services and products
                                        portfolio information, and transaction
                                        pattern and behaviour collected, compiled,
                                        generated or held by us from time to time;
                                        and
                                    </li>
                                    <li>
                                        to market and promote the updates, services
                                        and products from time to time available
                                        relating to us.
                                    </li>
                                </ul>
                                <p>
                                    G. If you agree to our use of Your Data in
                                    direct marketing, please tick (√) the box in the
                                    corresponding reply slip or data collection form
                                    to exercise your opt-in right. A sample of such
                                    is as follows:
                                </p>

                                <div class="reply-slip mt-4">
                                    <h5 class="mb-3">
                                        Reply Slip / Data Collection Form
                                    </h5>
                                    <p class="mb-0">
                                        I have read the Personal Information
                                        Collection Statement of Star Jasmine
                                        Employment Centre, including the information
                                        about the use of my personal data in direct
                                        marketing, and I understand its contents. By
                                        ticking the box below, I signify my consent
                                        for Star Jasmine Employment Centre to use my
                                        personal data (primarily my name and contact
                                        details) in direct marketing updates,
                                        services and products as more particularly
                                        set out in the Personal Information
                                        Collection Statement.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "PrivacyPage",
    components: {
        NavBar,
        SiteFooter,
    },
};
</script>

<style scoped>
.privacy-content p,
.privacy-content li {
    font-size: 15px;
    line-height: 1.8;
    color: #4a5568;
}
.privacy-content ul {
    padding-left: 24px;
    margin-bottom: 1rem;
}
.privacy-content li {
    margin-bottom: 8px;
}
.reply-slip {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 24px;
}
</style>
